var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarranty = function SvgWarranty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13Z",
    fill: "#84B841"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.027 7.958c-5.007.246-6.799-1.476-7.01-1.722 0 0 0-.017-.017-.017l-.018.017c-.228.246-2.003 1.968-7.01 1.722 0 0-1.756 8.977 6.94 12.508 0 0 .052.035.07.035.035.018.088-.035.088-.035 8.713-3.548 6.957-12.508 6.957-12.508Zm-2.706 3.004-4.04 5.516a.6.6 0 0 1-.457.246h-.035a.638.638 0 0 1-.457-.193l-2.81-3.092a.61.61 0 0 1 .034-.86.632.632 0 0 1 .879.034l2.319 2.548 3.601-4.92c.193-.28.58-.333.86-.14.247.194.317.58.106.861Z",
    fill: "#fff"
  })));
};
export default SvgWarranty;